module.exports = __webpack_public_path__ + "img/doctor.df261a85.svg";